export const redirectUrl =
  "https://10xhealthnetwork.com/pages/genetic-testing?utm_source=Ke2Nation";
